export const INTENT_STORAGE_KEY = "passport.launch.intent";
export const PLAYER_STORAGE_KEY = "passport.launch.playerId";
// FOOTGUN: this key holds the course GUID (e.g. "cl_74ud8389799552") from the launch
// context, NOT the numeric passport courseID. Resolve via `courseGUID` (getStudentCourses)
// before using it as a route param or assignments-API arg.
export const CLASS_ID_STORAGE_KEY = "passport.launch.classId";
export const ACTIVITY_ID_STORAGE_KEY = "passport.launch.activityId";
export const LAUNCH_ID_STORAGE_KEY = "passport.launch.launchId";
export const SCHOOL_ID_STORAGE_KEY = "passport.launch.schoolId";

export const INTENT_PICK = "PICK";
export const INTENT_PERFORM = "PERFORM";

export type LaunchIntent = typeof INTENT_PICK | typeof INTENT_PERFORM;
